export const awsVolumePaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/volumes`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/volumes`,
  detail: (connectionId, region, volumeId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/volumes/${encodeURIComponent(region)}/${encodeURIComponent(volumeId)}`,
  delete: (connectionId, region, volumeId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/volumes/${encodeURIComponent(region)}/${encodeURIComponent(volumeId)}`,
  attach: (connectionId, region, volumeId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/volumes/${encodeURIComponent(region)}/${encodeURIComponent(volumeId)}/attach`,
  detach: (connectionId, region, volumeId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/volumes/${encodeURIComponent(region)}/${encodeURIComponent(volumeId)}/detach`,
  resize: (connectionId, region, volumeId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/volumes/${encodeURIComponent(region)}/${encodeURIComponent(volumeId)}/resize`,
  snapshot: (connectionId, region, volumeId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/volumes/${encodeURIComponent(region)}/${encodeURIComponent(volumeId)}/snapshot`,
};
